// Copyright 2018 The MathWorks, Inc.

define([
    "dojo/_base/declare",
    "dijit/_Container",
    "dijit/_TemplatedMixin",
    "dijit/_WidgetBase",
    "MW/toolstrip/widgets/_WidgetMixin",
    "./RegionMixin",
    "dojo/text!./templates/StatusGroup.html"
], function (declare, _Container, _TemplatedMixin, _WidgetBase, _WidgetMixin, RegionMixin, template) {
    return declare([_WidgetBase, _Container,_TemplatedMixin, _WidgetMixin, RegionMixin], {

        templateString: template

    });
});